import styled from 'styled-components';
import tw from 'tailwind.macro';

export const Footer = styled.footer`
  ${tw`border-t border-gray-200 py-4`};
`;

export const Links = styled.div`
  ${tw`flex items-center justify-center w-full`};

  a {
    ${tw`text-indigo-900 mx-2`};
  }

  p {
    ${tw`text-indigo-900 mx-2`};
  }
`;

export const Link = styled.a`
  ${tw`text-blue-700 hover:text-blue-600 mx-2 text-lg`};
`;

export const Author = styled.div`
  ${tw`flex items-center justify-center w-full`};

  p {
    ${tw`text-grey-300 text-xs`};
  }
`;